import styled from 'styled-components';

export const DiagnosticPhotosGalleryActionsContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
